var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50.9508,
    height: 50.9508,
    rx: 25.4754,
    fill: "#2D53DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3537 36.5651L33.724 32.8873C34.404 32.4946 34.7433 32.2983 34.9906 32.0236C35.2094 31.7806 35.3749 31.4944 35.4759 31.1834C35.5898 30.8328 35.5898 30.4409 35.5898 29.6594V22.2929C35.5898 21.5113 35.5898 21.1195 35.4759 20.7688C35.3749 20.4579 35.2094 20.1714 34.9906 19.9284C34.7444 19.6549 34.4058 19.4595 33.7316 19.0702L27.3525 15.3873C26.6725 14.9946 26.3332 14.7987 25.9717 14.7219C25.6518 14.6539 25.3212 14.6539 25.0013 14.7219C24.6398 14.7987 24.2994 14.9946 23.6193 15.3873L17.2478 19.0658C16.5686 19.458 16.2292 19.6539 15.9821 19.9284C15.7633 20.1714 15.5981 20.4579 15.497 20.7688C15.3828 21.1203 15.3828 21.5131 15.3828 22.2984V29.6542C15.3828 30.4394 15.3828 30.832 15.497 31.1834C15.5981 31.4944 15.7633 31.7806 15.9821 32.0236C16.2294 32.2983 16.569 32.4946 17.249 32.8873L23.6193 36.5651C24.2993 36.9578 24.6398 37.1538 25.0013 37.2306C25.3212 37.2986 25.6518 37.2986 25.9717 37.2306C26.3332 37.1538 26.6737 36.9578 27.3537 36.5651Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9863 25.9761C21.9863 27.9091 23.5533 29.4761 25.4863 29.4761C27.4193 29.4761 28.9863 27.9091 28.9863 25.9761C28.9863 24.0431 27.4193 22.4761 25.4863 22.4761C23.5533 22.4761 21.9863 24.0431 21.9863 25.9761Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSet);
export default __webpack_public_path__ + "static/media/Set.8b0ef4fb18443722f4fe02c5e5b73db2.svg";
export { ForwardRef as ReactComponent };